/* Editorial browsing only. No product, price, cart or checkout mutations. */
(() => {
  'use strict';
  function initialize(scope = document) {
    scope.querySelectorAll('[data-klik-home-tabs]').forEach(list => {
      if (list.dataset.klikHomeBound) return;
      list.dataset.klikHomeBound = 'true';
      const region = list.closest('.klik-home__ready');
      const tabs = Array.from(list.querySelectorAll('[data-klik-home-tab]'));
      const activate = tab => {
        tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          let next;
          const rtl = getComputedStyle(region).direction === 'rtl';
          if (event.key === 'ArrowRight') next = (index + (rtl ? -1 : 1) + tabs.length) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + (rtl ? 1 : -1) + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          activate(tabs[next]);
          tabs[next].focus();
        });
      });
      if (tabs.length) activate(tabs[0]);
      list.hidden = false;
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-klik-scene][open]').forEach(scene => {
      if (!scene.contains(event.target)) scene.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-klik-scene][open]').forEach(scene => {
      const hasFocus = scene.contains(document.activeElement);
      scene.open = false;
      if (hasFocus) scene.querySelector('summary')?.focus();
    });
  });
})();
